import styled from "@emotion/styled";
import {config} from "../../config/utils";
import {useState} from "react";

const EnvironmentFlag = () => {
    const [show, setShow] = useState(config.showEnvLabel);
    const hide = () => {
        setShow(false);
        setTimeout(() => setShow(true), 10000);
    }
    return (<>
        {
            show && <>
                <TopRightFlag onClick={hide}>
                    {config.environment}
                </TopRightFlag>
                <BottomLeftFlag onClick={hide}>
                    {config.environment}
                </BottomLeftFlag>
            </>
        }
    </>);
}

const TopRightFlag = styled.div`
  position: fixed;
  top: 15px;
  right: -25px;
  background-color: #ff0000;
  color: #fff;
  padding: 1px 30px;
  transform: rotate(40deg);
  font-size: 10px;
  z-index: 99999999;
  :hover {
    opacity: 0.2;
    cursor: pointer;
  }
`;

const BottomLeftFlag = styled.div`
  position: fixed;
  bottom: 15px;
  left: -25px;
  background-color: #ff0000;
  color: #fff;
  padding: 1px 30px;
  transform: rotate(40deg);
  font-size: 10px;
  z-index: 99999999;
  :hover {
    cursor: pointer;
    opacity: 0.2;
  }
`;

export default EnvironmentFlag;